import { Crown, Lock, Crosshair, Zap, Brain, Megaphone, Shield, MessageCircle } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES, CONTACT, PRIVATE_DETAILS } from "../data/content";

const ICONS = { Crown, Lock, Crosshair, Zap, Brain, Megaphone, Shield };

export default function PrivateTraining() {
  return (
    <main className="pt-20 sm:pt-24">
      <section className="relative py-40 overflow-hidden noise-overlay" data-testid="private-hero">
        <img src={IMAGES.elite1} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <img src={IMAGES.heroFire} alt="" className="absolute inset-0 w-full h-full object-cover mix-blend-screen opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-[#050505]/40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
          <Reveal>
            <Overline>Private Training</Overline>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter max-w-3xl" data-testid="private-headline">
              The Gap Between You and Them <span className="text-[#D4AF37]">Starts Here.</span>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-24" data-testid="private-details">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {PRIVATE_DETAILS.map((d, i) => {
              const Icon = ICONS[d.icon];
              return (
                <Reveal key={d.title} delay={i * 0.05}>
                  <div className="bg-[#050505] p-10 lg:p-12 h-full transition-colors duration-300 hover:bg-[#0F0F0F]" data-testid={`private-detail-${i}`}>
                    <Icon size={26} className="text-[#D4AF37] mb-6" />
                    <h3 className="font-heading text-xl font-bold text-white">{d.title}</h3>
                    <p className="text-white/50 text-sm leading-relaxed mt-3">{d.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal className="mt-16">
            <a
              href={CONTACT.whatsappPrivate}
              target="_blank"
              rel="noreferrer"
              data-testid="private-cta-whatsapp"
              className="inline-flex items-center gap-3 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-sm px-10 py-4 rounded-sm transition-all duration-200 hover:bg-[#F3D059] hover:-translate-y-1 gold-glow"
            >
              <MessageCircle size={16} /> WhatsApp Us If You're Interested
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
